import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/opt/render/project/src/node_modules/.pnpm/gatsby-theme-docz@2.3.1_@babel+core@7.11.1_@types+node@24.7.0_docz@2.4.0_@babel+core@7._04842b0c5656885ffb9b2f355e30df2b/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "lowkeyui-styleguide--component-inventory"
    }}>{`LowkeyUI Styleguide — Component Inventory`}</h1>
    <p>{`Produced by the Task 2 discovery sweep (2026-06-10). Status meanings:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`source-confirmed`}</strong>{` — real source file located during the sweep`}</li>
      <li parentName="ul"><strong parentName="li">{`verify-at-build`}</strong>{` — seeded from the old HTML doc; plausible but source/details confirmed at build time (recipe step 1)`}</li>
      <li parentName="ul"><strong parentName="li">{`suspect`}</strong>{` — no source found in the sweep; likely hallucinated in the old doc. Verified at build time and dropped if nothing real exists.`}</li>
      <li parentName="ul"><strong parentName="li">{`new`}</strong>{` — real component the old HTML doc missed`}</li>
    </ul>
    <p>{`Sweep facts worth keeping:`}</p>
    <ul>
      <li parentName="ul">{`The `}<inlineCode parentName="li">{`lowkey:`}</inlineCode>{` Tailwind variant (tailwind.config.js:268) has `}<strong parentName="li">{`zero`}</strong>{` usages in JSX — all lowkey styling flows through `}<inlineCode parentName="li">{`app.css`}</inlineCode>{` selectors and flag checks (`}<inlineCode parentName="li">{`lowKeyUi`}</inlineCode>{` / `}<inlineCode parentName="li">{`lowKeyForms`}</inlineCode>{` from `}<inlineCode parentName="li">{`components/feature-flags`}</inlineCode>{`).`}</li>
      <li parentName="ul">{`Legacy pre-lowkey classes still exist in app.css (`}<inlineCode parentName="li">{`kp-button-brand`}</inlineCode>{`, `}<inlineCode parentName="li">{`kp-button-solid`}</inlineCode>{`, `}<inlineCode parentName="li">{`kp-button-danger`}</inlineCode>{`, `}<inlineCode parentName="li">{`kp-modal`}</inlineCode>{`, `}<inlineCode parentName="li">{`kp-modal-full`}</inlineCode>{`, `}<inlineCode parentName="li">{`kp-button-lg`}</inlineCode>{`); the styleguide must not present them as lowkey.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`.lowkey`}</inlineCode>{`/`}<inlineCode parentName="li">{`.lowkey-forms`}</inlineCode>{` go on `}<inlineCode parentName="li">{`<html>`}</inlineCode>{` via `}<inlineCode parentName="li">{`app/src/index.jsx:82-86`}</inlineCode>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "build-queue"
    }}>{`Build queue`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`#`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Section`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Kind`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Source(s)`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Status`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Buttons (all variants + modifiers)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`atom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`app.css:234-378`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed (Task 3)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`2`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Text input`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`atom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`app.css:384-386, 429-431 (`}<inlineCode parentName="td">{`kp-input`}</inlineCode>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`3`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Textarea`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`atom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`app.css:380-382, 433-435 (`}<inlineCode parentName="td">{`kp-textarea`}</inlineCode>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`4`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Select + select-transparent`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`atom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`app.css:388-398, 437-441 (`}<inlineCode parentName="td">{`kp-select`}</inlineCode>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`5`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Input group (icons L/R, button-right, active)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`atom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`app.css:400-426, 521-531 (`}<inlineCode parentName="td">{`kp-input-group`}</inlineCode>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`6`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Checkbox + indeterminate`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`atom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`app.css:506-513; ui/checkbox.jsx; ui/indeterminate-checkbox.jsx`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`7`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Radio`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`atom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`app.css:516-518; ui/radios.jsx`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`8`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Field label + required`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`atom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`app.css:501-503 (`}<inlineCode parentName="td">{`kp-label`}</inlineCode>{`), app.css:230-232 (`}<inlineCode parentName="td">{`kp-required`}</inlineCode>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`9`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Field view (read-only)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`atom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`app.css:444-463 (`}<inlineCode parentName="td">{`kp-field-view`}</inlineCode>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`10`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Rich text view`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`atom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`app.css:466-479 (`}<inlineCode parentName="td">{`kp-rich-text-view`}</inlineCode>{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`11`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Datepicker (input group + popup)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`atom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`components/temporal-pickers.jsx; app.css:534-539`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`12`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Toggle`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`atom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`ui/toggle.jsx`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`new`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`13`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Segmented control`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`atom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`ui/segmented-control.jsx`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed (old doc called it "button group")`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`14`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Link`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`atom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`kp-link`}</inlineCode>{` (app.css)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`new`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`15`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Badge`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`atom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`kp-badge`}</inlineCode>{` (app.css); status pills verify-at-build`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`16`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Chip (lookup value)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`atom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`kp-chip`}</inlineCode>{` (app.css); ui/lookup.jsx`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`17`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Table`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`atom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`kp-table`}</inlineCode>{`, `}<inlineCode parentName="td">{`kp-table-clickable`}</inlineCode>{` (app.css)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`18`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Avatar / abbreviation icon`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`atom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`components/abbreviation-icon.jsx`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`19`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Spinner`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`atom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`components/spinner.jsx`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`20`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Skeleton`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`atom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`ui/shadcn/skeleton.tsx`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`new`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`21`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Separator`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`atom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`ui/shadcn/separator.tsx`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`new`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`22`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Tooltip`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`atom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`ui/tooltip.tsx; components/tooltip (provider in root-layout)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`23`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Tabs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`atom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`ui/tabs.jsx`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`24`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Alerts (types 1/2/3: modal-style, inline, toast)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`molecule`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`ui/alerts.jsx (AlertsProvider, useAlerts)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`25`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Banner (header notice)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`molecule`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`components/header-layout.jsx, home-layout.jsx`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`verify-at-build`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`26`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Info box / config box`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`molecule`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`ui/info-box.jsx; ui/config-box.jsx`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`new`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`27`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Popover / dropdown menu`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`molecule`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`ui/popover.jsx; ui/shadcn/popover.tsx; ui/shadcn/dropdown-menu.tsx`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`28`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Pop-up (modal/dialog)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`molecule`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`ui/pop-up.jsx`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`29`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Side panel`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`molecule`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`kp-modal-side`}</inlineCode>{` + `}<inlineCode parentName="td">{`kp-slide-right`}</inlineCode>{` (app.css:569-571); ui/shadcn/sheet.tsx`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`30`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Pulse badge`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`atom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`kp-pulse-badge-before/-after`}</inlineCode>{` (app.css)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`31`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Drag handle / reorderable list`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`molecule`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`components/reorderable-list.jsx`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`32`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Search bar`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`molecule`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`components/search-bar.jsx; components/data-table/search-bar.jsx`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`33`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Data-table controls (columns button, popover button)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`molecule`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`components/data-table/columns-button.jsx, popover-button.jsx`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`34`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Section card (odd/even depth, header, collapse)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`molecule`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`app.css:542-566, 617-647 (`}<inlineCode parentName="td">{`lkf-section*`}</inlineCode>{`); formbot section gadget`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`35`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Workflow tracker / step pill`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`molecule`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`pages-runner/action/workflow-tracker/`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`36`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Document list row`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`molecule`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`pages-builder/document-list/`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`verify-at-build`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`37`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`User menu`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`molecule`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`components/user-menu.jsx`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`38`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Pages nav`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`molecule`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`components/pages-nav/index.jsx`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`39`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Sidebar (dark + light maintenance variant)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`organism`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`components/sidebar/index.jsx; app.css:574-594 (`}<inlineCode parentName="td">{`lowkey-sidebar-light`}</inlineCode>{`); ui/shadcn/sidebar.tsx`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`40`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Modal with field form + footer actions`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`molecule (composition)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`ui/pop-up.jsx + form atoms`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`composition — build from confirmed atoms`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`41`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Card/section with labeled fields (view + edit)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`molecule (composition)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`lkf-section + kp-label/kp-input/kp-field-view`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`composition`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`42`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Table with mixed gadget cells`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`molecule (composition)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`kp-table + formbot gadget cell rules (app.css:481-498)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`composition`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`43`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Filter bar (input group + select + button)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`molecule (composition)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`confirmed atoms`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`composition`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`44`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Layout: app shell (sidebar + main)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`layout`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`components/app-layout.jsx`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`45`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Layout: header layout (dark top bar)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`layout`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`components/header-layout.jsx`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`46`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Layout: form builder 3-panel`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`layout`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`pages-builder/form/index.jsx (config panel `}<inlineCode parentName="td">{`lg:w-[350px]`}</inlineCode>{` + canvas + props)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`verify-at-build`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`47`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Layout: runner 1-panel (formbot container page)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`layout`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`components/formbot-container/`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`source-confirmed`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "dropped--reclassified-from-the-old-html-doc"
    }}>{`Dropped / reclassified from the old HTML doc`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Old doc section`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Disposition`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Sticky header (31) / Action bar (32)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No standalone component found; these are aspects of formbot-container / form pages. Folded into layouts #45-47; verified there.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Compare-changes popup (33)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No source found in sweep — `}<strong parentName="td">{`suspect`}</strong>{`. One build-time search (document compare / version diff screens); dropped if nothing real.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Button group (12)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Reclassified → segmented control (ui/segmented-control.jsx), #13.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Field spinner (in 34)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Verify within #19 spinner section; drop if not a real pattern.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`All `}<inlineCode parentName="td">{`lkf-btn-*`}</inlineCode>{` class names & stone-colored primary palette`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Hallucinated; real names are `}<inlineCode parentName="td">{`kp-*`}</inlineCode>{`, real primary is `}<inlineCode parentName="td">{`var(--primary, #0c4a6e)`}</inlineCode>{` with `}<inlineCode parentName="td">{`hover:bg-sky-950`}</inlineCode>{`.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Checked off as built; statuses updated at each section's build step.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      